// Reducers //
import { reducer as broadcastingReducer } from './match/slice'
import { reducer as eventsReducer } from './events/slice'
import { reducer as geniusReducer } from './genius/slice'
import { reducer as hardwareReducer } from './hardware/slice'
import { reducer as pitchesReducer } from './pitches/slice'
import { reducer as peopleReducer } from './people/slice'
import { reducer as sportscasterReducer } from './sportscaster/slice'
import { reducer as teamPeopleReducer } from './team_people/slice'
import { reducer as teamPersonSessionsReducer } from './team_person_sessions/slice'
import { reducer as hardwareSessionsReducer } from './hardware_sessions/slice'
import { reducer as sessionsReducer } from './sessions/slice'
import { reducer as teamsReducer } from './teams/slice'
import { reducer as unitsReducer } from './units/slice'
import { reducer as teamSessionsReducer } from './team_sessions/slice'
import { reducer as usersReducer } from './users/slice'
import { reducer as organisationsReducer } from './organisations/slice'
import { reducer as sportsReducer } from './sports/slice'
import { reducer as regionsReducer } from './regions/slice'
import { reducer as laptopsReducer } from './laptops/slice'
import { reducer as metricsServerReducer } from './metrics_server/slice'
import { reducer as uploadStatusReducer } from './upload_status/slice'
import { reducer as syncStatusReducer } from './sync_status/slice'
import { reducer as reportingReducer } from './reporting/slice'

export const domainReducers = {
  broadcasting: broadcastingReducer,
  events: eventsReducer,
  genius: geniusReducer,
  hardware: hardwareReducer,
  pitches: pitchesReducer,
  people: peopleReducer,
  sessions: sessionsReducer,
  sportscaster: sportscasterReducer,
  teamPeople: teamPeopleReducer,
  teamPersonSessions: teamPersonSessionsReducer,
  hardwareSessions: hardwareSessionsReducer,
  teamSessions: teamSessionsReducer,
  teams: teamsReducer,
  units: unitsReducer,
  users: usersReducer,
  organisations: organisationsReducer,
  sports: sportsReducer,
  regions: regionsReducer,
  laptops: laptopsReducer,
  metricsServer: metricsServerReducer,
  uploadStatus: uploadStatusReducer,
  syncStatus: syncStatusReducer,
  reporting: reportingReducer
}

export const domainApiMiddlewares = []
